import request from '@/utils/request'

export default {
  // 搜索导出记录
  searchExportRecord(data) {
    return request({
      url: '/admin/commonExportRecord/list',
      method: 'post',
      data
    })
  },
  // 药企导出记录
  businessExportRecord(data) {
    return request({
      url: '/business/commonExportRecord/list',
      method: 'post',
      data,
      privateFlag: true
    })
  }
}
